import Background from './background';
import ForeGround from './foreground';

window.onload = function() {
    new ForeGround();
    new Background();

    document.querySelector('.js-date').textContent = ` ${new Date().getFullYear()} - `;
}